module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [(_vm.calendarInstance) ? _c('div', {
    staticClass: "calendar-toolbar d-flex align-items-center jumbotron mb-4 py-4"
  }, [_c('h2', {
    staticClass: "m-0"
  }, [_vm._v(_vm._s(_vm.visibleDate))]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 justify-content-end d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.toggleTypeManager
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("planning.createType")) + "\n                  ")]), _vm._v(" "), _c('general-select', {
    staticClass: "calendar-type-select",
    attrs: {
      "placeholder": "Selecteer een type",
      "options": _vm.calendarTypeOptions
    },
    on: {
      "input": _vm.setCalendarType
    },
    model: {
      value: (_vm.selectedCalendarType),
      callback: function($$v) {
        _vm.selectedCalendarType = $$v
      },
      expression: "selectedCalendarType"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "vr mx-4"
  }), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "type": "button",
      "variant": "outline-primary",
      "title": "Verander kalender"
    },
    on: {
      "click": _vm.viewToggle
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" - \n                     " + _vm._s(_vm.$t(("planning." + _vm.calendarView))) + "\n                  ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": "Ga naar vandaag"
    },
    on: {
      "click": _vm.moveToday
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": ("Vorige " + (_vm.$t(("planning." + _vm.calendarView))))
    },
    on: {
      "click": _vm.movePrev
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "button",
      "variant": "outline-secondary",
      "title": ("Volgende " + (_vm.$t(("planning." + _vm.calendarView))))
    },
    on: {
      "click": _vm.moveNext
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calendar-container jumbotron py-4"
  }, [_c('calendar', {
    ref: "calendar",
    attrs: {
      "calendars": _vm.calendarTypes,
      "schedules": _vm.selectedCalendarSchedules,
      "view": _vm.calendarView,
      "week": _vm.week,
      "month": _vm.month,
      "useCreationPopup": false,
      "useDetailPopup": false,
      "usageStatistics": false,
      "taskView": false,
      "defaultView": "month",
      "disabled": ""
    },
    on: {
      "beforeCreateSchedule": _vm.beforeCreate,
      "beforeUpdateSchedule": _vm.beforeUpdate,
      "clickSchedule": _vm.clickSchedule
    }
  })], 1)]), _vm._v(" "), (_vm.mode == 'typeManager') ? [_c('div', {
    staticClass: "col-4"
  }, [_c('type-manager', {
    attrs: {
      "calendarTypes": _vm.calendarTypes
    },
    on: {
      "update": _vm.updatedTypes,
      "close": function($event) {
        _vm.mode = 'calendar'
      }
    }
  })], 1)] : (_vm.mode == 'timeSlot') ? [_c('div', {
    staticClass: "col-4"
  }, [_c('timeslot', {
    attrs: {
      "selectedTime": _vm.selectedTime,
      "selectedSchedule": _vm.selectedSchedule,
      "calendarTypes": _vm.calendarTypes
    },
    on: {
      "close": _vm.closeAppointment,
      "update": _vm.updatedTimeSlot,
      "delete": _vm.deletedTimeSlot
    }
  })], 1)] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-611dd4c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Planning/Main.vue
// module id = 1317
// module chunks = 1